const ID_COMPREHENSIVE_TREATMENT = ["dev", "staging"].includes(
  process.env.VUE_APP_MODE
)
  ? 17808
  : 23003;

const POLLING_INTERVAL = 4000;
const MAX_POLL_ATTEMPS = 5;

// แบบฟอร์มคลินิกไม่มี paging ใน UI — ขอมาทีเดียวให้ครบ
// ถ้าสาขาไหนมีเกิน limit จะได้ของใหม่สุดก่อน (DESC) ไม่ใช่ของเก่าที่ค้างอยู่
const TEMPLATE_FETCH_PARAMS = {
  limit: 200,
  sort: "creationDt",
  // API validate ตัวพิมพ์เล็กเท่านั้น (enum: asc, desc) — "DESC" โดน 400
  order: "desc",
};

const FILE_LIMIT_EXCEED = {
  title: "พื้นที่เก็บข้อมูลเต็ม",
  message:
    "การอัปโหลดไฟล์ล้มเหลวเนื่องจากพื้นที่เก็บข้อมูลเต็ม กรุณาลบไฟล์ที่ไม่จำเป็นหรือ ติดต่อฝ่ายสนับสนุนเพื่อขอความช่วยเหลือเพิ่มเติม",
  icon: "warning",
};
const FILE_STORAGE_PLAN_EXPIRED = {
  title: "การสมัครสมาชิกหมดอายุ",
  message:
    "การอัปโหลดไฟล์ล้มเหลวเนื่องจากการสมัครสมาชิกของคุณหมดอายุ กรุณาต่ออายุการสมัครสมาชิกหรือ ติดต่อฝ่ายสนับสนุนเพื่อขอความช่วยเหลือเพิ่มเติม",
  icon: "warning",
};

const ERROR_MESSAGE_USER_REQUEST_PRINT_RECEIPT =
  "Payment process terminated: User requested receipt printing";

const REDIIVIEW_BASE_URL = "https://dservice-dc.radiiview.com/linkurl";

const THAI_MONTHS = [
  "ม.ค.",
  "ก.พ.",
  "มี.ค.",
  "เม.ย.",
  "พ.ค.",
  "มิ.ย.",
  "ก.ค.",
  "ส.ค.",
  "ก.ย.",
  "ต.ค.",
  "พ.ย.",
  "ธ.ค.",
];

module.exports = {
  ID_COMPREHENSIVE_TREATMENT,
  POLLING_INTERVAL,
  MAX_POLL_ATTEMPS,
  TEMPLATE_FETCH_PARAMS,
  FILE_LIMIT_EXCEED,
  FILE_STORAGE_PLAN_EXPIRED,
  ERROR_MESSAGE_USER_REQUEST_PRINT_RECEIPT,
  REDIIVIEW_BASE_URL,
  THAI_MONTHS,
};
